export default __webpack_public_path__ + "static/media/glitch03.60663675.png";